import { Ruler } from '@phosphor-icons/react';
import MasterTable from './MasterTable';
import { mfgApi } from './mfgApi';

const UOM_API = {
  list: mfgApi.uoms,
  create: mfgApi.createUom,
  update: mfgApi.updateUom,
  remove: mfgApi.deleteUom,
};
const UOM_LABELS = {
  title: 'mfg.uom.title', desc: 'mfg.uom.desc', name: 'mfg.uom.name',
  namePh: 'mfg.uom.namePh', add: 'mfg.uom.add', empty: 'mfg.uom.empty', usage: 'mfg.uom.usage',
};

export default function Uoms() {
  return (
    <div data-testid="mfg-uoms">
      <MasterTable api={UOM_API} prefix="uom" labels={UOM_LABELS} Icon={Ruler} />
    </div>
  );
}
